import { TopToolbar, useListContext, usePermissions } from "react-admin";
import BankAdd from "./BankAdd";
import CustomExportButton from "../unit/CustomExportButton";
const BankListActions = () => {
  const { total } = useListContext();
  const { permissions } = usePermissions();
  const admin = localStorage.getItem("authrole");
  return (
    <>
      <TopToolbar sx={{ width: "100%" }}>
        {admin == "admin" && <BankAdd />}
        {/* <CustomFilterButton /> */}
        <CustomExportButton />
      </TopToolbar>
    </>
  );
};

export default BankListActions;
